import DataTable from "@/components/ui/DataTable";
import { AdhocItem } from "@/models/adhoc-items.model";
import { useLocation } from "react-router-dom";
import { getColumns } from "./columns";
import PayItemDataTable from "../../PayItemDataTable";

import PayItemDialogContainer from "../../dialog/PayItemDialogContainer";
import AddAdhocForm from "./AddAdhocForm";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { getAdhocItems } from "@/api/adhoc-items";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
}

function AdhocTab({ userId, month, year, payslipId }: Props) {
  const [adhocItems, setAdhocItems] = useState<AdhocItem[]>([]);

  const updateAdhocItems = (adhocItem: AdhocItem) => {
    setAdhocItems([...adhocItems, adhocItem]);
  };

  const deleteAdhocItem = (id: number) => {
    const updatedItems = adhocItems.filter((item) => item.id !== id);
    setAdhocItems(updatedItems);
  };

  useEffect(() => {
    const fetchAdhoc = async () => {
      const res = await getAdhocItems({ userId, month, year });
      setAdhocItems(res);
    };
    fetchAdhoc();
  }, [userId, month, year]);

  return (
    <div className="flex flex-col gap-3 p-5">
      <div className="flex justify-between">
        <div>
          <div className="text-lg font-bold">Adhoc Allowance (CPF)</div>
          <div className="w-full flex flex-col">
            <div>Includes overtime, off-days, public holidays etc.</div>
          </div>
        </div>
        <PayItemDialogContainer
          title="Add Adhoc Allowance"
          description="Includes overtime, off-days, public holidays etc."
          form={
            <AddAdhocForm
              userId={userId}
              month={month}
              year={year}
              payslipId={payslipId}
              updateAdhocItems={updateAdhocItems}
            />
          }
        />
      </div>

      <PayItemDataTable
        columns={getColumns(deleteAdhocItem)}
        data={adhocItems}
        header="Current items"
      />
    </div>
  );
}

export default AdhocTab;
